module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/H2-1afab6021f0fa7e6c4d38724a9570011c4ad85a0698aa448b3e3dab868e10b3f.svg";